import { FieldModel } from '@cibo/core'
import { NaturalDisturbanceCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface NaturalDisturbanceCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
}

export const NaturalDisturbanceCell = ({
  value,
  task,
  selectedField,
  year,
}: NaturalDisturbanceCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="naturalDisturbance"
    >
      <NaturalDisturbanceCellDisplay value={value} />
    </TraitCellContainer>
  )
}
